<div class="login-page font-normal">
    <div class="login-container">
      <div class="header p-10 flex items-center">
        <div class="img-cntr">
          <img src="./images/logo.png" width="100" height="100" alt="NCMS" />
        </div>
        <div class="m-auto">
          <h1>NIGERIA CASE MANAGEMENT SYSTEM</h1>
        </div>
      </div>
      <div class="content-center">
        <div class="login-info">
          <form class="flex flex-col px-6" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <h2 class="text-xl mb-4">Reset Password</h2>
      
            <mat-form-field class="rounded-md">
              <mat-icon matPrefix fontIcon="lock" class="border-r border-solid text-slate-400"></mat-icon>
              <input [type]="toggleShowoldPwd() ? 'text' : 'password'" formControlName="oldPassword" matInput placeholder="Old Password" />
              <mat-icon
                matSuffix
                [fontIcon]="toggleShowoldPwd() ? 'visibility' : 'visibility_off'"
                class="border-l border-solid text-slate-400 cursor-pointer"
                (click)="togglePwd('old')"
              ></mat-icon>
              <mat-error class="!text-white">Field value required</mat-error>
            </mat-form-field>
      
            <mat-form-field class="rounded-md">
              <mat-icon matPrefix fontIcon="lock" class="border-r border-solid text-slate-400"></mat-icon>
              <input [type]="toggleShowNewPwd() ? 'text' : 'password'" formControlName="newPassword" matInput placeholder="New Password" (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()"
              (paste)="$event.preventDefault()" />
              <mat-icon
                matSuffix
                [fontIcon]="toggleShowNewPwd() ? 'visibility' : 'visibility_off'"
                class="border-l border-solid text-slate-400 cursor-pointer"
                (click)="togglePwd('new')"
                
              ></mat-icon>
              <mat-error class="!text-white">Field value required</mat-error>
            </mat-form-field>
      
            <mat-form-field class="rounded-md">
              <mat-icon matPrefix fontIcon="lock" class="border-r border-solid text-slate-400"></mat-icon>
              <input [type]="toggleShowConfirmPwd() ? 'text' : 'password'" formControlName="confirmPassword" matInput placeholder="Confirm Password" (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()"
              (paste)="$event.preventDefault()" />
              <mat-icon
                matSuffix
                [fontIcon]="toggleShowConfirmPwd() ? 'visibility' : 'visibility_off'"
                class="border-l border-solid text-slate-400 cursor-pointer"
                (click)="togglePwd('confirm')"
                
                            ></mat-icon>
              <mat-error class="!text-white">Field value required</mat-error>
            </mat-form-field>
      
            <div class="flex flex-wrap gap-3 justify-center mt-4">
              <button type="submit" mat-flat-button class="btn-sign">Submit</button>
              <button type="reset" mat-flat-button class="btn-sign" (click)="onReset()">Reset</button>
            </div>
          </form>
        </div>
      </div>
      
      </div>
     
    </div>
  
  